import labels from "emun.invoice/_labels";
import crLabels from "emun.invoice/credit-request/_labels";
import CreditRequestContainerController from "emun.invoice/credit-request/credit-request-container.controller";
import creditRequestPrompt from "emun.invoice/credit-request/credit-request-prompt";
import creditRequestConfig from "emun.invoice/credit-request/credit-request.config";
import config from "emun.invoice/invoice.config";
import ReturnItemPrompt from "emun.invoice/return-item-prompt";
import $appConfig from "servicestack/config";
import _ from "underscore";
import modals from "webmodals/modals";
import mediaManagerPrompt from "webutils/media/media-manager-prompt";

export default class CreditRequestDetailsController extends CreditRequestContainerController {
  getQueries() {
    const $ctrl = this;
    $ctrl.labels = labels;
    $ctrl.crLabels = crLabels;
    $ctrl.config = config;
    $ctrl.creditRequestConfig = creditRequestConfig;
    return {
      creditRequestDb: {
        ...super.getQuery(),
        criteria: {
          Search: $ctrl.creditRequestId,
        },
        views: {},
        filters: [],
        disableQueryString: true,
        pageSize: 1,
        onLoaded: (args) => $ctrl.onCreditRequestLoaded(args.first),
      },
      invoiceDb: {
        url: "QueryInvoices.json",
        criteria: {
          invoiceNumber: $ctrl.id,
        },
        autoLoad: false,
        onLoaded: (args) => $ctrl.onInvoiceLoaded(args.first),
      },
      productsDb: {
        url: "QueryProducts.json",
        criteria: {
          
        },
        autoLoad: false,
        onLoaded: (args) => $ctrl.onProductsLoaded(args.results),
      },
    };
  }

  $onInit() {
    console.debug("CreditRequestDetailsController", this);
  }

  onProductsLoaded(products) {
    const $ctrl = this;
    // console.debug("onProductsLoaded", products);
    $ctrl.productsMap = products.reduce(
      (m, p) => Object.assign(m, { [p.id]: p }),
      {}
    );
    $ctrl.invoice.lines.forEach(
      (c) => (c.product = $ctrl.productsMap[c.productId])
    );
    if ($ctrl.creditRequest) {
      $ctrl.hydrateCreditRequestLines();
    }
    $ctrl.buildCreditLines();
  }

  onInvoiceLoaded(invoice) {
    // console.debug('onInvoiceLoaded', invoice);
    const $ctrl = this;
    $ctrl.invoice = invoice;
    //$ctrl.productsDb.criteria.IdIn = invoice.lines.map((c) => c.productId);
    $ctrl.productsDb.criteria.RetailerId = invoice.retailerId;
    $ctrl.productsDb.criteria.InvoiceId = invoice.id;
    // console.debug('$ctrl.productsDb.criteria.IdIn', $ctrl.productsDb.criteria.IdIn);
    //if ($ctrl.productsDb.criteria.IdIn.length) $ctrl.productsDb.load(true);
    if ($ctrl.productsDb.criteria.InvoiceId) $ctrl.productsDb.load(true);
    // console.warn('$ctrl.creditRequestDb', $ctrl.creditRequestDb);
    // console.warn('isBusy', $ctrl.creditRequestDb.isBusy());
    if (invoice && !$ctrl.creditRequest) {
      $ctrl.creditRequest = cm;
      $ctrl.creditRequestDb.criteria.Search =
        invoice.id || invoice.invoiceNumber;
      $ctrl.creditRequestDb.load(true);
    }
    //$ctrl.buildCreditLines();
  }

  onCreditRequestLoaded(cm) {
    // console.debug('onCreditRequestLoaded', cm);
    const $ctrl = this;
    if (cm) {
      $ctrl.creditRequest = cm;
      $ctrl.invoiceDb.criteria.invoiceNumber = cm.invoiceId;
    } else {
      $ctrl.invoiceDb.criteria.invoiceNumber = $ctrl.id;
    }
    $ctrl.invoiceDb.load(true);
    $ctrl.buildCreditLines();
  }

  productImage(productId, size = "thumbnail") {
    return $appConfig.productImage(productId, size);
  }

  manageMedia(line) {
    const $ctrl = this;
    // console.debug("manageMedia", line, $ctrl);
    return mediaManagerPrompt({
      realm: "ReturnRequest",
      tagCriteria: {
        $creditmemoId: $ctrl.creditRequest.id,
        $invoiceLineNumber: line.invoiceLineNumber,
      },
      title: crLabels.abbr + "ed Item Images: " + line.productId,
    });
  }

  hydrateCreditRequestLines() {
    const $ctrl = this;
    const byPos = _.indexBy($ctrl.creditRequest.lines, "invoiceLineNumber");
    for (let il of $ctrl.invoice.lines) {
      if (byPos[il.position]) {
        byPos[il.position].productId = il.productId;
        byPos[il.position].productDescription = il.description;
        if ($ctrl.productsMap) {
          byPos[il.position].product = $ctrl.productsMap[il.productId];
          console.debug(il.position, {
            il,
            crl: byPos[il.position],
            p: $ctrl.productsMap[il.productId],
          });
        }
      }
    }
    // console.debug("hydrateCreditRequestLines", byPos);
    return byPos;
  }

  buildCreditLines() {
    const $ctrl = this;
    $ctrl.returns = [];
    //console.debug("CreditRequestDetailsController.buildCreditLines", this);
    if ($ctrl.creditRequest && $ctrl.invoice) {
      const byPos = $ctrl.hydrateCreditRequestLines();
      //console.debug("CreditRequestDetailsController.buildCreditLines", $ctrl.invoice.lines);
      $ctrl.creditLines = $ctrl.invoice.lines
        .map((il) =>
          Object.assign(
            {
              qtyReturned: 0,
              quantity: 0,
              invoiceLineNumber: "" + il.position,
              productId: il.productId,
            },
            il,
            byPos[il.position]
          )
        )
        .filter(
          (cl) =>
            cl.qtyShipped > 0 &&
            (cl.qtyReturned || $ctrl.creditRequest.status === "Open")
        );
      $ctrl.returns = $ctrl.creditLines.filter((o) => o.qtyReturned > 0);

      // console.debug(
      //   "CreditRequestDetailsController.$returns",
      //   $ctrl.returns
      // );
      $ctrl.creditLines.forEach((cl) => (cl.quantity = cl.qtyReturned));
    }
  }

  return(line) {
    const $ctrl = this;
    line.quantity = Math.min(line.qtyShipped, 1);
    return ReturnItemPrompt({
      creditmemo: $ctrl.creditRequest,
      invoice: $ctrl.invoice,
      line,
      title: crLabels.abbr + "ed Item: " + line.productId,
      subTitle: line.description,
    }).then(() => $ctrl.creditRequestDb.load(true));
  }

  edit() {
    const $ctrl = this;
    creditRequestPrompt({
      transitionTo: false,
      retailerId: $ctrl.invoice.retailerId,
      model: Object.assign({}, $ctrl.creditRequest),
    }).then((res) => $ctrl.onEdited(res));
  }

  setStatus(request) {
    const $ctrl = this;
    $ctrl.bus.send("UpdateCreditMemoRequest.json", request).then(function () {
      $ctrl.$emit("creditRequestSaved", $ctrl);
      $ctrl.creditRequestDb.load(true);
    });
  }

  submit() {
    const $ctrl = this;
    $ctrl.hydrateCreditRequestLines();
    creditRequestPrompt({
      commandLabel: "Submit",
      transitionTo: false,
      title: `Submit Request: ${$ctrl.invoice.id}`,
      retailerId: $ctrl.invoice.retailerId,
      $parent: $ctrl,
      model: Object.assign({}, $ctrl.creditRequest, {
        status: "Submitted",
      }),
    }).then((res) => $ctrl.onSubmitted(res));
  }

  onEdited() {
    const $ctrl = this;
    console.debug("onEdited", this);
    $ctrl.$emit("creditRequestSaved", $ctrl);
    $ctrl.creditRequestDb.load(true);
  }

  onSubmitted() {
    const $ctrl = this;
    if ($ctrl.creditRequestConfig.creditRequestSubmissionMessage)
      modals.alert($ctrl.creditRequestConfig.creditRequestSubmissionMessage);
    console.debug("onSubmitted", this);
    $ctrl.$emit("creditRequestSaved", $ctrl);
    $ctrl.creditRequestDb.load(true);
    // $ctrl.$state.go("^.list", {
    //   invoiceId: $ctrl.invoice.id,
    //   retailerId: $ctrl.invoice.retailerId
    // });
  }

  changeQuantity(line) {
    const $ctrl = this;
    if (line.quantity > line.qtyShipped) {
      alert("Quantity cannot be greater than " + line.qtyShipped);
      line.quantity = line.qtyShipped;
      return;
    }
    if (line.id) {
      if (line.quantity > 0) {
        return $ctrl.bus
          .send("UpdateCreditMemoRequestLine", line)
          .then(() => {});
      } else {
        return modals
          .confirm("Are you sure?", "Delete credit line")
          .result.then(function () {
            $ctrl.bus.send("DeleteCreditMemoRequestLine", line).then(() => {
              $ctrl.credits = [];
              $ctrl.creditRequestDb.load();
            });
          });
      }
    } else {
      return $ctrl.bus
        .send("CreateCreditMemoRequestLine", line)
        .then((response) => {
          line.id = response.data.id;
        });
    }
  }

  incrementQty(line) {
    const $ctrl = this;
    line.quantity += 1;
    $ctrl.changeQuantity(line);
  }

  decrementQty(line) {
    const $ctrl = this;
    line.quantity -= 1;
    $ctrl.changeQuantity(line);
  }
}
